import { BaseTag }   from "mixs/base/base_mixin";

class Index extends BaseTag {
  init(){
    super.init();
    this.watch();
  }
  diff_status_class(diff){
    if(diff){ return'' }
    return 'bg-danger'
  }
  diff_status_icon(diff){
    if(diff){ return'' }
    return 'fas fa-exclamation'
  }
  diff_client_name_class(diff){
    return this.diff_str(diff)
  }
  diff_product_name_class(diff){
    return this.diff_str(diff)
  }
  diff_client_name_icon(diff){
    return this.diff_icon(diff)
  }
  diff_product_name_icon(diff){
    return this.diff_icon(diff)
  }

  diff_str(diff){
    if(diff > 0.75){
      return '';
    }else if (diff > 0.45){
      return 'border-info text-info'
    }else if (diff > 0.2){
      return 'border-warning text-warning'
    }else {
      return 'border-danger text-danger'
    }
  }

  diff_icon(diff){
    if(diff > 0.75){
      return '';
    }else if (diff > 0.45){
      return 'fas fa-info'
    }else if (diff > 0.2){
      return 'fas fa-exclamation'
    }else {
      return 'fas fa-exclamation'
    }
  }

  diff_deadline_class(diff, diff_month_flg){
    if(diff_month_flg){
      return 'bg-danger'
    }else if(Math.abs(diff) >= 14 ){
      return 'bg-warning'
    }else if(Math.abs(diff) >= 7 ){
      return 'bg-info'
    }else if(Math.abs(diff) != 0 ){
      return 'border-success text-success'
    }else{
      return '';
    }
  }

  diff_deadline_icon(diff, diff_month_flg){
    if(diff_month_flg){
      return 'fas fa-exclamation'
    }else if(Math.abs(diff) >= 14 ){
      return 'fas fa-exclamation'
    }else if(Math.abs(diff) >= 7 ){
      return 'fas fa-info'
    }else if(Math.abs(diff) != 0 ){
      return 'fas fa-info'
    }else{
      return '';
    }
  }
}

riot.mixin('orders.result-checking-orders-csv', Index as riot.TagMixin)
